import React, { FC, useState, useCallback, useEffect } from 'react'
import { cn } from 'shared/utils'

import {Tag} from '../../shared/__gql-types'

import { TagsProps } from './Tags.props'

import './Tags.scss'

const Tags: FC<TagsProps> = ({
  onReset,
  onSelect,
  onSelectTag,
  onUnselectTag,
  className = '',
  reset,
  tagsList,
  dataTest,
  theme = 'dark',
  initialTagsValue = [],
  isCentered = false
}) => {
  const [selected, setSelected] = useState<Tag[]>([])

  useEffect(() => {
    if (initialTagsValue.length) setSelected(initialTagsValue)
  }, [initialTagsValue])

  useEffect(() => {
    if (reset && onReset) {
      onReset()
      setSelected([])
    }
  }, [onReset, reset])

  const selectTag = useCallback(
    (tag) => () => {
      if (selected.some(({ id }) => id === tag.id)) {
        const filteredSelectedTags = selected.filter(({ id }) => id !== tag.id)

        setSelected(filteredSelectedTags)
        onUnselectTag && onUnselectTag(tag.id)
        onSelect && onSelect(filteredSelectedTags)
      } else {
        const updatedSelectedTags = [...selected, tag]

        onSelectTag && onSelectTag(tag.id)
        setSelected(updatedSelectedTags)
        onSelect && onSelect(updatedSelectedTags)
      }
    },
    [onSelect, onSelectTag, onUnselectTag, selected]
  )

  return (
    <div className={cn('tags', `tags--${theme}`, className, { 'tags--centered': isCentered })}>
      {tagsList.map(({ label, order_number, id }, index) => {
        const isActive = selected.some((item) => item.label === label)

        return (
          <div
            className={cn('tags__item', {
              active: isActive
            })}
            key={`tag_${index}`}
            data-test={`${dataTest}-option`}
            onClick={selectTag({ label, order_number, id })}
          >
            {label}
          </div>
        )
      })}
    </div>
  )
}

export default Tags
